import { TokenDataAliasSchema, tokenAliasOrValue } from "./base";
import { OpacityTokenData } from "./opacity";
import { z } from "zod";
export const ColorValue = z.object({
    opacity: OpacityTokenData,
    color: z.string().or(TokenDataAliasSchema),
});
export const ColorTokenData = tokenAliasOrValue(ColorValue);
